// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import '@/components/common/font.css'

// 兼容旧的 hash 路由链接（如 panbrain.cn/#/device），301 到 history 路径
if (window.location.hash && window.location.hash.indexOf("#/") === 0) {
  const hashPath = window.location.hash.slice(1);
  window.history.replaceState(null, "", hashPath + window.location.search);
}

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js